module.exports = __webpack_public_path__ + "img/qr-alert.a00fefe5.svg";